// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"21bb08f9","72":"23f846e8","294":"21bb08f9","519":"566fb667","587":"3f369d66","951":"21bb08f9"}[chunkId] + ".chunk.css";
};